import {Injectable} from '@angular/core';
import {NotifierService} from "angular-notifier";

@Injectable({
	providedIn: 'root'
})
export class MessageService {

	static DEFAULT = 'default';
	static SUCCESS = 'success';
	static INFO = 'info';
	static ALERT = 'warning';
	static ERROR = 'error';

	public constructor(private notifier: NotifierService) {

	}

	public showSuccess(message: string, id?: string): void {
		this.notifier.notify(MessageService.SUCCESS, message, id);
	}

	public showDefault(message: string, id?: string): void {
		this.notifier.notify(MessageService.DEFAULT, message, id);
	}

	public showAlert(message: string, id?: string): void {
		this.notifier.notify(MessageService.ALERT, message, id);
	}

	public showError(message: string, id?: string): void {
		this.notifier.notify(MessageService.ERROR, message, id);
	}

	public showInfo(message: string, id?: string): void {
		this.notifier.notify(MessageService.INFO, message, id);
	}

	public showResponseError(response: any): void{
		let error = response.error;
		let messages: Array<string> = [];
		let status:number = 0;
		if(response.hasOwnProperty('status')){
			status = response.status;
		}else if(response.hasOwnProperty('status_code')){
			status = response.status_code;
		}else if(response.error){
			if(response.error.hasOwnProperty('status')){
				status = response.error.status;
			}else if(response.error.hasOwnProperty('status_code')){
				status = response.error.status_code;
			}
		}

		if (status == 0) {
			messages.push("Ocorreu um erro ao carregar os dados, verifique a conexão com a internet");
		} else if (status == 405) { //method not allowed
			messages.push("Ocorreu um erro ao carregar os dados, por favor tente novamente");
		} else if (status == 401 && error.hasOwnProperty("error") && error.error == 'invalid_credentials') {
			messages.push("Usuário e/ou senha inválidos");
		} else if(status == 500 && (error.message == "Unauthenticated." || response.error.message == "Unauthenticated.")) {
			messages.push("Seu login expirou, para acessar a funcionalidade é necesário entrar novamente no sistema");
		} else if (error.hasOwnProperty('errors')) {
			for (let key in error.errors) {
				for (let msg of error.errors[key]) {
					messages.push(msg);
				}
			}
		}

		if (messages.length == 0 && error.message) {
			messages.push(error.message);
		}
		if(messages.length > 0){
			messages.forEach((message: string) => {
				this.showError(message);
			});
		}
	}

	public hideOldestMessage(): void {
		this.notifier.hideOldest();
	}

	public hideNewestMessage(): void {
		this.notifier.hideNewest();
	}

	public hideAllMessages(): void {
		this.notifier.hideAll();
	}

	public hideMessage(id: string): void {
		this.notifier.hide(id);
	}
}
